var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWall3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1012.08 879.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#6479a6;}.cls-3{fill:#afc4e2;}.cls-4{fill:#9aadca;}.Graphic-Style-2{fill:#8ab3ff;opacity:0.5;mix-blend-mode:screen;}.cls-5{fill:#788bb2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M988.8,330.66,423.56,4.32v219L992.13,551.58ZM586.49,224.38,436.86,138V39l149.63,86.38Zm172.89,99.83L609.76,237.82v-99l149.62,86.39ZM929,422.11,779.33,335.72v-99L929,323.11Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "450.18 133.63 586.02 212.11 586.49 224.38 436.86 138 450.18 133.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "436.86 138 436.86 39 449.84 46.67 450.18 133.63 436.86 138"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "623.07 233.45 758.92 311.93 759.38 324.21 609.76 237.82 623.07 233.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "609.76 237.82 609.76 138.82 622.74 146.49 623.07 233.45 609.76 237.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "792.65 331.35 928.49 409.83 928.96 422.11 779.33 335.73 792.65 331.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "779.33 335.73 779.33 236.72 792.31 244.39 792.65 331.35 779.33 335.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic-Style-2",
    d: "M436.86,39l149.63,86.38v99L436.86,138Zm172.9,198.82,149.62,86.39v-99L609.76,138.82Zm169.57,97.9L929,422.11v-99L779.33,236.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 645.95 0 657.95 1008.75 330.18 436.86 0 423.56 4.32 982.15 326.82 0 645.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M875.76,439.36l69.82-22.69v156l66.5-21.61-3.33-220.92L0,658V880L875.76,595.4ZM679.58,586.84,526.9,636.64v-126l152.68-49.5Zm19.95-6.19v-126l152.69-49.5v125.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "839.18 523.28 699.53 568.65 699.53 580.65 852.22 530.85 839.18 523.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "666.55 579.27 526.9 624.64 526.9 636.64 679.59 586.84 666.55 579.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "666.95 465.13 666.55 579.27 679.59 586.84 679.59 461.13 666.95 465.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "839.18 523.28 852.22 530.85 852.22 405.15 839.58 409.14 839.18 523.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "945.58 572.71 932.28 565.03 932.28 421.03 945.51 416.67 945.58 572.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic-Style-2",
    d: "M852.22,530.85l-152.69,49.8v-126l152.69-49.5ZM679.58,461.14,526.9,510.64v126l152.68-49.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall3);
export default __webpack_public_path__ + "static/media/wall-3.1eb512b4c95aaa28a0d736209afd3a9b.svg";
export { ForwardRef as ReactComponent };